import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '../styles';
import GrassInfoColumn from '../components/GrassInfoColumn';
import GrassInfoRow from '../components/GrassInfoRow';
import images from '~/constants/images';
import { propTypes, defaultProps } from './propsValidation';
import { HeaderContext } from '~/context';
import { Icon } from '~/components';
import downloadFile from '~/utils/downloadFile';

export default function GrassStatus({
  grassStatus,
  irrigationProgram,
  publicFiles,
}) {
  const { t } = useTranslation();
  const { setButtonRight, setHeaderProps, headerProps } = useContext(
    HeaderContext
  );
  useEffect(() => {
    if (!Object.keys(headerProps).length) {
      setButtonRight(
        <Icon
          name="download"
          color={
            Object.keys(publicFiles.data).length === 0 ||
            !publicFiles.data.greenkeeper
              ? 'light2Opacity'
              : 'white'
          }
          onClick={() => {
            if (publicFiles.data.greenkeeper)
              downloadFile(publicFiles.data.greenkeeper.id);
          }}
        />
      );
    }
  }, [setButtonRight, headerProps, publicFiles]);
  useEffect(() => {
    return () => {
      setHeaderProps({});
    };
  }, [setHeaderProps]);

  return (
    <S.GreenKeeperContainer>
      <S.GrassImage>
        <S.GrassImageColumn center>
          <img src={images.grass} alt="" />
        </S.GrassImageColumn>
        <S.GrassImageColumn left>
          <div>
            <GrassInfoColumn
              icon="grass"
              data={
                grassStatus.grassCompounds ? grassStatus.grassCompounds : '-'
              }
              label={t('grassType')}
            />
            <GrassInfoColumn
              icon="height"
              data={grassStatus.grassHeight ? grassStatus.grassHeight : '-'}
              label={`${t('grassHeight')} (mm)`}
            />
          </div>
        </S.GrassImageColumn>
        <S.GrassImageColumn right>
          <div>
            <GrassInfoColumn
              icon="hibryd"
              data={grassStatus.isHybridSystem ? t('yes') : t('no')}
              label={t('grasshybrid')}
            />
            <GrassInfoColumn
              icon="hibrydSystem"
              data={grassStatus.hybridSystem ? grassStatus.hybridSystem : '-'}
              label={t('hybridSystem')}
            />
          </div>
        </S.GrassImageColumn>
        <S.GrassImageColumn bottom>
          <div>
            <GrassInfoColumn
              icon="program"
              data={irrigationProgram}
              label={t('grassProgram')}
              bottom
            />
          </div>
        </S.GrassImageColumn>
      </S.GrassImage>
      <GrassInfoRow title={t('meteorology')}>
        <GrassInfoColumn
          icon="temperature"
          data={
            grassStatus.weatherForecastTemperature
              ? grassStatus.weatherForecastTemperature
              : '-'
          }
          label={`${t('temperature')} (ºC)`}
          inColumn
        />
        <GrassInfoColumn
          icon="humidity"
          data={
            grassStatus.weatherForecastHumidity
              ? grassStatus.weatherForecastHumidity
              : '-'
          }
          label={`${t('relativeHumidity')} (%)`}
          inColumn
        />
        <GrassInfoColumn
          icon="precipitations"
          data={
            grassStatus.weatherForecastRainfallType
              ? grassStatus.weatherForecastRainfallType
              : '-'
          }
          label={t('precipitations')}
          inColumn
        />
      </GrassInfoRow>
      <GrassInfoRow title={t('pitch')}>
        <GrassInfoColumn
          icon="dimensions"
          data={
            grassStatus.venueHeight && grassStatus.venueWidth
              ? `${grassStatus.venueHeight} x ${grassStatus.venueWidth}`
              : '-'
          }
          label={`${t('dimensions')} (m)`}
          inColumn
        />
        <GrassInfoColumn
          icon="temperature"
          data={
            grassStatus.grassTemperature ? grassStatus.grassTemperature : '-'
          }
          label={`${t('floorTemperarure')} (ºC)`}
          inColumn
        />
        <GrassInfoColumn
          icon="hardness"
          data={grassStatus.hardnessGround ? grassStatus.hardnessGround : '-'}
          label={`${t('floorHardness')} (G)`}
          inColumn
        />
      </GrassInfoRow>
    </S.GreenKeeperContainer>
  );
}

GrassStatus.propTypes = propTypes;
GrassStatus.defaultProps = defaultProps;
